import { createConfirmation } from 'react-confirm'
import ModalBody from "./ModalBody";

const modal = createConfirmation(ModalBody);

export default function (opts = {}) {
  return modal(opts);
}



// WEBPACK FOOTER //
// ./src/template/Modals/ForgotPassword/index.js